import React, { useContext, useState } from 'react';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import CustomDialog from '../custom-dialog/custom-dialog';
import {
  DialogTitle,
  Typography,
  DialogContent,
  Stack,
  Button,
  CircularProgress,
  DialogActions,
  TextField,
} from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import axios from 'axios';
import { API_ENDPOINT } from '../../../configurations/global.config';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { format } from 'date-fns';
import { useSnackBar } from '../../../contexts/snackbar';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ConfirmAction from '../confirm-action/confirm-action';

interface UnfreezeOrderDialogProps {
  orders: OrderType[];
  onSuccess: () => void;
  onClose: () => void;
}

function UnfreezeOrderDialog({
  orders,
  onClose,
  onSuccess,
}: UnfreezeOrderDialogProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { config } = useContext(AuthContext);
  const { showMessage } = useSnackBar();
  const pluralSuffix = orders.length > 0 ? 's' : '';

  const unfreeze = async () => {
    try {
      setLoading(true);
      await axios.post<OrderType>(
        `${API_ENDPOINT}/api/v1/orders/bulk-unfreeze/`,
        { order_ids: orders.map((o) => o.id) },
        config
      );
      showMessage(`Order${pluralSuffix} unfrozen!`);
      onSuccess && onSuccess();
      onClose();
    } catch {
      showMessage(`Failed to unfreeze order${pluralSuffix}`, 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    setError('');

    try {
      setLoading(true);
      await unfreeze();
    } catch (err) {
      setError('Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmAction
      message={'Are you sure you want to unfreeze selected order(s)'}
      action={function (reason?: string): void {
        handleSubmit();
      }}
      isOpen={true}
      handleClose={onClose}
    >
      {' '}
    </ConfirmAction>
  );
}

export default UnfreezeOrderDialog;
